import { attempt } from "@omni/utils/function.utils";
import classNames from "classnames";
import { CountryCode, parsePhoneNumber } from "libphonenumber-js";

import { Translate } from "@/redux/modules/value/translations/translations.provider";

const TooltipTemplate = (
    t: Translate,
    store: woosmap.map.stores.Store,
    storeUrl?: string
) => {
    if (!storeUrl) {
        return "";
    }

    const parsedPhoneNumber = attempt(
        () => {
            const phoneObject = parsePhoneNumber(
                store.contact.phone,
                store.address.country_code! as CountryCode
            );
            return {
                label: phoneObject.formatInternational(),
                uri: phoneObject.getURI()
            };
        },
        { label: store.contact.phone, uri: `tel:${store.contact.phone}` }
    );

    const addressLines = store.address.lines?.join(", ");
    const addressCity = `${store.address.zipcode} ${store.address.city}`;

    const open = store.open.open_now;

    const statusText = t(
        `form.searchstore.storeCard.status.${open ? "open" : "closed"}`
    );

    return `<section>
        <p class="store-card__title">${store.name}</p>
        <p class="${classNames(
            "store-status mb-0",
            open && "store-status--open"
        )}">
            <span>${statusText}</span>
        </p>
        <p class="m-0"}>
            ${addressLines}, ${addressCity}
        </p>
        <p class="w-auto mb-0">
            <a href="${parsedPhoneNumber.uri}">${parsedPhoneNumber.label}</a>
        </p>
        <a href="${storeUrl}">
            ${t("form.searchstore.storeCard.moreInfo")}
        </a>
    </section>`;
};

export { TooltipTemplate };
